import React, { Component } from "react";
import { Switch } from "react-router-dom";

import PrivateRoute from "../../utils/PrivateRoute";
import PageNotFound from "../shared/components/notices/PageNotFound";

import PurchaseOrderUpload from "./containers/PurchaseOrderUpload";
import PurchaseOrderDetails from "./containers/PurchaseOrderDetails";
import PurchaseOrderContactForm from "./containers/PurchaseOrderContactForm";

class PurchaseOrderRoutes extends Component {
  render() {
    return (
      <Switch>
        <PrivateRoute
          exact
          path="/purchase_orders/:id/new"
          component={PurchaseOrderUpload}
        />
        <PrivateRoute
          exact
          path="/purchase_orders/:id/add_contact"
          component={PurchaseOrderContactForm}
        />
        <PrivateRoute
          exact
          path="/purchase_orders/new"
          component={PurchaseOrderUpload}
        />
        <PrivateRoute
          exact
          path="/purchase_orders/:id"
          component={PurchaseOrderDetails}
        />
        <PrivateRoute component={PageNotFound} />
      </Switch>
    );
  }
}

export default PurchaseOrderRoutes;



// WEBPACK FOOTER //
// ./src/features/trade_documents/purchaseOrderRoutes.js